export default import.meta.ROLLDOWN_FILE_URL_$JdR2re7WHPfcroInHOXqg